import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'hash', // hash or history
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
         // news
        {
            path: '/news',
            name: 'news',
            component: () => import('./views/news.vue')
        },
         // alltype
        {
            path: '/typedetail',
            name: 'typedetail',
            component: () => import('./views/typedetail.vue')
        },
        // alltype
        {
            path: '/alltype',
            name: 'alltype',
            component: () => import('./views/alltype.vue')
        },
        // 1
        {
            path: '/photosview',
            name: 'photosview',
            component: () => import('./views/photosview.vue')
        },
        // 楼盘概括
        {
            path: '/housedesc',
            name: 'housedesc',
            component: () => import('./views/housedesc.vue')
        },
        // 登录页
        {
            path: '/Login',
            name: 'login',
            component: () => import('./views/Login.vue')
        },
        // 个人中心
        {
            path: '/UserCenter',
            name: 'userCenter',
            component: () => import('./views/UserCenter.vue')
        },
        // 个人中心-个人设置
        {
            path: '/UserSetting',
            name: 'userSetting',
            component: () => import('./views/UserSetting.vue')
        },
        // 个人中心-认证经纪人
        {
            path: '/Certification',
            name: 'certification',
            component: () => import('./views/Certification.vue')
        },
        // 个人中心-委托中心
        {
            path: '/ConsignCenter',
            name: 'consignCenter',
            component: () => import('./views/ConsignCenter.vue')
        },
        // 个人中心-委托中心-我要投标
        {
            path: '/Bided',
            name: 'bided',
            component: () => import('./views/Bided.vue')
        },
        // 发布委托
        {
            path: '/PublishCommission',
            name: 'publishCommission',
            component: () => import('./views/PublishCommission.vue')
        },
        // 个人中心-我的问题
        {
            path: '/ProblemList',
            name: 'problemList',
            component: () => import('./views/ProblemList.vue')
        },
        // 个人中心-我的问题-发布问题
        {
            path: '/PutQuestion',
            name: 'putQuestion',
            component: () => import('./views/PutQuestion.vue')
        },
        // 经纪人
        {
            path: '/ListUser',
            name: 'listUser',
            component: () => import('./views/ListUser.vue')
        },
        // 经纪人详情
        {
            path: '/DetailUser',
            name: 'detailUser',
            component: () => import('./views/DetailUser.vue')
        },
        // 经纪人攻略详情
        {
            path: '/DetailStrategy',
            name: 'detailStrategy',
            component: () => import('./views/DetailStrategy.vue')
        },
        // 开发区
        {
            path: '/Development',
            name: 'development',
            component: () => import('./views/Development.vue')
        },
        // 开发区-详情
        {
            path: '/DevelopmentDetail',
            name: 'developmentDetail',
            component: () => import('./views/DevelopmentDetail.vue')
        },
        // 开发区-详情-查看详情
        {
            path: '/DevelopmentDetails',
            name: 'developmentDetails',
            component: () => import('./views/DevelopmentDetails.vue')
        },
        // 开发区-详情-二级页面
        {
            path: '/DevelopmentTwo',
            name: 'developmentTwo',
            component: () => import('./views/DevelopmentTwo.vue')
        },
        // 楼盘
        {
            path: '/PropertyList',
            name: 'propertyList',
            component: () => import('./views/PropertyList.vue')
        },
        // 楼盘-详情
        {
            path: '/Property',
            name: 'property',
            component: () => import('./views/Property.vue')
        },
        // 楼盘-详情-详细
        {
            path: '/DetailInfoBuilding',
            name: 'detailInfoBuilding',
            component: () => import('./views/DetailInfoBuilding.vue')
        },
        // 房源
        {
            path: '/HouseList',
            name: 'houseList',
            component: () => import('./views/HouseList.vue')
        },
        // 房源-详情
        {
            path: '/House',
            name: 'house',
            component: () => import('./views/House.vue')
        },
        // 问答
        {
            path: '/Question',
            name: 'question',
            component: () => import('./views/Question.vue')
        },
        // 问答详情
        {
            path: '/QuestionDetail',
            name: 'questionDetail',
            component: () => import('./views/QuestionDetail.vue')
        },
        // 资讯列表
        {
            path: '/NewsList',
            name: 'newsList',
            component: () => import('./views/NewsList.vue')
        },
        // 资讯-详情
        {
            path: '/DetailInfoView',
            name: 'detailInfoView',
            component: () => import('./views/DetailInfoView.vue')
        },
        // 关注列表
        {
            path: '/FocusList',
            name: 'focusList',
            component: () => import('./views/FocusList.vue')
        },
        // 我的楼盘列表
        {
            path: '/UserBuildingList',
            name: 'userBuildingList',
            component: () => import('./views/UserBuildingList.vue')
        },
        // 我的楼盘列表
        {
            path: '/UserHouseList',
            name: 'userHouseList',
            component: () => import('./views/UserHouseList.vue')
        },
        // 我的攻略列表
        {
            path: '/UserStrategyList',
            name: 'userStrategyList',
            component: () => import('./views/UserStrategyList.vue')
        },
        // 我的投标列表
        {
            path: '/UserBidedList',
            name: 'userBidedList',
            component: () => import('./views/UserBidedList.vue')
        },
        // 我的委托列表
        {
            path: '/UserEntrustList',
            name: 'userEntrustList',
            component: () => import('./views/UserEntrustList.vue')
        },
        // 我的预约列表
        {
            path: '/UserAppointList',
            name: 'userAppointList',
            component: () => import('./views/UserAppointList.vue')
        },
        // 我的收藏
        {
            path: '/UserCollection',
            name: 'userCollection',
            component: () => import('./views/UserCollection.vue')
        },
        // 我的消息
        {
            path: '/UserMsg',
            name: 'userMsg',
            component: () => import('./views/UserMsg.vue')
        },
        // 搜索结果
        {
            path: '/SearchResult',
            name: 'searchResult',
            component: () => import('./views/SearchResult.vue')
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})
